var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecrypt4Squares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157 157",
    style: {
      enableBackground: "new 0 0 157 157"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#34DAE2;}\n\t.st2{fill:#252A41;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st4{fill:#E3E3E3;}\n\t.st5{opacity:0.1;fill:#231F20;enable-background:new    ;}\n\t.st6{fill:#D54B3D;}\n\t.st7{fill:#D72B27;}\n\t.st8{fill:url(#Path_677_1_);}\n\t.st9{fill:#005FAC;}\n\t.st10{fill:#5F01D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-33.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    transform: "translate(33.908 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    className: "st0",
    d: "M22.47,6.73c-0.03-0.63-0.03-1.22-0.03-1.82c0.01-0.46-0.36-0.84-0.82-0.85 c-0.01,0-0.02,0-0.03,0c-3.55,0-6.25-1.02-8.5-3.21c-0.34-0.31-0.86-0.31-1.19,0c-2.24,2.19-4.94,3.21-8.5,3.21 C2.94,4.06,2.56,4.42,2.55,4.89c0,0.01,0,0.02,0,0.03c0,0.6,0,1.19-0.03,1.82c-0.11,5.97-0.28,14.15,9.69,17.59l0.28,0.06 l0.28-0.06C22.73,20.89,22.59,12.73,22.47,6.73z M11.82,15c-0.17,0.14-0.38,0.23-0.6,0.23h-0.03c-0.23,0-0.45-0.11-0.6-0.28 l-2.64-2.93l1.28-1.14l2.07,2.3l4.6-4.38l1.17,1.25L11.82,15z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    transform: "translate(-1249.332 -383.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546_1_",
    className: "st1",
    d: "M1288.29,499.91l6.82-5.7l3.67,6.69l-8.06,2.82l8.06,2.75l-3.93,6.95l-6.56-5.77l1.64,8.52 h-7.67l1.57-8.52l-6.49,5.84l-4.06-7.08l8.06-2.82l-8-2.62l3.74-6.75l6.82,5.7l-1.71-8.65h7.8L1288.29,499.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    className: "st1",
    d: "M1249.33,467.01v73.39h73.39v-73.39H1249.33z M1312.51,530.2h-52.97v-52.97h52.97V530.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546-2",
    className: "st1",
    d: "M1371.9,499.91l6.82-5.7l3.67,6.69l-8.06,2.82l8.06,2.75l-3.93,6.95l-6.56-5.77l1.64,8.52 h-7.67l1.57-8.52l-6.49,5.84l-4.06-7.08l8.06-2.82l-8-2.62l3.74-6.75l6.82,5.7l-1.71-8.65h7.8L1371.9,499.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    className: "st1",
    d: "M1332.94,467.01v73.39h73.39v-73.39H1332.94z M1396.12,530.2h-52.97v-52.97h52.97L1396.12,530.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546-3",
    className: "st1",
    d: "M1288.29,416.3l6.82-5.7l3.67,6.69l-8.06,2.82l8.06,2.75l-3.93,6.95l-6.56-5.77l1.64,8.52 h-7.67l1.57-8.52l-6.49,5.84l-4.06-7.08l8.06-2.82l-8-2.62l3.74-6.75l6.82,5.7l-1.71-8.65h7.8L1288.29,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    className: "st1",
    d: "M1249.33,383.4v73.39h73.39V383.4H1249.33z M1312.51,446.59h-52.97v-52.97h52.97V446.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546-4",
    className: "st1",
    d: "M1371.9,416.3l6.82-5.7l3.67,6.69l-8.06,2.82l8.06,2.75l-3.93,6.95l-6.56-5.77l1.64,8.52 h-7.67l1.57-8.52l-6.49,5.84l-4.06-7.08l8.06-2.82l-8-2.62l3.74-6.75l6.82,5.7l-1.71-8.65h7.8L1371.9,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    className: "st1",
    d: "M1332.94,383.4v73.39h73.39V383.4H1332.94z M1396.12,446.59h-52.97v-52.97h52.97L1396.12,446.59 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecrypt4Squares);
export default __webpack_public_path__ + "static/media/recrypt_4_squares.433b80c6.svg";
export { ForwardRef as ReactComponent };